export default "__VITE_ASSET__BcvPUBLc__"